import store from '../store/index';

/**
 * @typedef {import("vue-router").Route} Route
 */

/**
 * Class for handling route paths
 */
export default class RouterService {
  /**
   * clean path from url
   * @param {Route} route
   */
  static setPath(route = '') {
    // show home widgets in middle column only if we are on default home layout
    if (route.name === 'home') {
      store.commit('showAfterRouteWidgets');
    }
    const layoutName = this.getLayoutName(route);
    store.commit('setCurrentLayoutFromRoute', layoutName);
  }

  /**
   * Get layout name based on route
   * @param {Route} route 
   */
  static getLayoutName(route = '') {
    let pathParts = route.path.toString().trim().split('/');
    if (pathParts[0] === '') {
      pathParts.shift();
    }
    let currRoute = typeof pathParts[0] !== 'undefined' || pathParts[0] !== null ? decodeURIComponent(pathParts[0]) : '';
    let layoutName = currRoute.replace('-', ' ');
    // first entry in the array will be our layout name
    if (!this.checkLayoutName(layoutName)) {
      layoutName = '';
    }
    return layoutName;
  }

  /**
   * Check if route layout name is in layouts list
   * @param {string} layoutName - Route layout name
   */
  static checkLayoutName(layoutName) {
    return store.state.LayoutModule.layouts.some(layout => layout.name === layoutName);
  }
}
